import { Component } from '@angular/core';

@Component({
  selector: 'app-comparison-instructions',
  templateUrl: './comparison-instructions.component.html',
  styleUrls: ['./comparison-instructions.component.scss']
})
export class ComparisonInstructionsComponent {
  scrollToSection(sectionId: string): void {
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
